// EventSource wrapper for the portal-api SSE proxy
// (/api/jobs/:jobId/events). Calls onEvent for each parsed JSON
// payload; calls onError on connection issues; returns a teardown.

import { API_BASE_URL, type BuildEvent } from "./api";

export function streamBuildEvents(
  jobId: string,
  onEvent: (e: BuildEvent) => void,
  onError?: (err: Event) => void,
): () => void {
  const url = `${API_BASE_URL}/api/jobs/${jobId}/events`;
  const es = new EventSource(url, { withCredentials: true });
  es.onmessage = (msg) => {
    try {
      const parsed = JSON.parse(msg.data) as BuildEvent;
      onEvent(parsed);
    } catch (err) {
      console.warn("[sse] failed to parse event", err);
    }
  };
  es.onerror = (err) => {
    onError?.(err);
  };
  return () => es.close();
}
